export const GET_LOGGED_OUT_DATA = "GET_LOGGED_OUT_DATA" 